import React from 'react';
import VetClinicDetailsCard from '../../components/pet-form/VetClinic/VetClinicDetailsCard';
import ErrorListClinics from '../../components/pet-form/VetClinic/ErrorListClinics';
import { Clinic, Clinics } from '../../components/pet-form/VetClinic/vetClinicResponse';

const PetProfileClinics = ({
  clinics,
  clinicError,
}: {
  clinics?: Clinics;
  clinicError?: boolean;
}) => {
  const clinicsHeader = 'Vet Clinics';

  return !!clinicError ? (
    <ErrorListClinics />
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {clinics && clinics.length > 0 && (
        <>
          <h3
            className="pet-profile__details--section-header pet-profile__details--section-header__vet"
            data-testid="pet-profile-details--section-clinics"
          >
            {clinicsHeader}
          </h3>
          <ul className="vet-list">
            {clinics.map((clinic: Clinic, index: number) => (
              <li
                key={index}
                className="pet-form-vet-list__card"
                data-testid="pet-form-vet-list-card"
                aria-label={`Clinic: ${clinic.name}.`}
              >
                <VetClinicDetailsCard clinic={clinic} />
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );
};

export default PetProfileClinics;
